export enum LanguageIds {
  danish = 2,
}
